/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDiamondAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.072 3.629A1 1 0 0 1 5 3h14a1 1 0 0 1 .928.629l2 5a1 1 0 0 1-.128.971l-9 12a1 1 0 0 1-1.6 0l-9-12a1 1 0 0 1-.128-.971zM5.677 5l-1.2 3h2.846l1.2-3zm5 0-1.2 3h5.046l-1.2-3zm4.8 0 1.2 3h2.846l-1.2-3zM19 10h-2.28l-1.823 5.47zm-7 7.838L14.613 10H9.387zM7.28 10H5l4.103 5.47z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDiamondAlt as DiamondAlt };
